export default __webpack_public_path__ + "static/media/18.b1fa0754.jpg";